import { Tooltip } from 'ui/tooltip';
import React from 'react';
import { useCampaignContext } from '../../context';
import { getTooltipContent } from '../utils';
import { useCampaignPermission } from './hooks';

type CampaignPermissionCheckType = {
  children: React.ReactElement | React.ReactElement[];
  ChildWrapper?: (props: any) => JSX.Element;
  action: string;
  additionalCheck?: boolean;
  additionalCheckTooltip?: string;
};

export const CampaignPermissionCheck = ({
  children,
  ChildWrapper,
  action = '',
  additionalCheck = false,
  additionalCheckTooltip = '',
}: CampaignPermissionCheckType) => {
  const {
    campaign: { messageMedium },
  } = useCampaignContext();
  const { hasManageMessagingAccess } = useCampaignPermission();

  /* Check for both permission to manage campaigns and for content errors.
  Permission message takes precedence over content error message. */
  const hasTooltip = !hasManageMessagingAccess || additionalCheck;
  const tooltipContent = !hasManageMessagingAccess
    ? getTooltipContent(action, messageMedium)
    : additionalCheckTooltip;

  if (hasTooltip) {
    return (
      <Tooltip isEnabled={hasTooltip} tooltipContent={tooltipContent}>
        {Array.isArray(children)
          ? React.Children.map(children, (child) =>
              React.cloneElement(child, { isDisabled: hasTooltip }),
            )
          : React.cloneElement(children, { isDisabled: hasTooltip })}
      </Tooltip>
    );
  }

  return ChildWrapper ? <ChildWrapper>{children}</ChildWrapper> : <>{children}</>;
};
